import { jsx, Fragment } from 'react/jsx-runtime';
import { useTabSwitchContext } from '../TabSwitch.Context/index.es.js';

const TabSwitchContent = ({ id, children })=>{
    const { tab } = useTabSwitchContext();
    return tab === id ? jsx(Fragment, {
        children: children
    }) : null;
};
TabSwitchContent.displayName = 'TabSwitch.Content';

export { TabSwitchContent };
//# sourceMappingURL=TabSwitch.Content.es.js.map
